<section
    *ngIf="content !== ''"
    [innerHTML]="content"
    class="container gx-0 px-2 px-md-0 container-rental-policy"
></section>
<section *ngIf="content === ''" class="container gx-0 px-2 px-md-0 container-rental-policy">
    <div
        [showPlaceholder]="true"
        fe-placeholder
        [content]="'Rent a car terms and conditions'"
        class="title-faq d-inline-block"
    ></div>
    <div>
        <p
            [showPlaceholder]="true"
            fe-placeholder
            [content]="contentParagragh"
            class="text-faq d-inline-block"
        ></p>
        <p
            [showPlaceholder]="true"
            fe-placeholder
            [content]="'Requirements for rent'"
            class="subtitle-faq d-inline-block"
        ></p>
        <p
            [showPlaceholder]="true"
            fe-placeholder
            [content]="contentParagragh"
            class="text-faq d-inline-block"
        ></p>
        <p
            [showPlaceholder]="true"
            fe-placeholder
            [content]="'Requirements for rent'"
            class="subtitle-faq d-inline-block"
        ></p>
        <p
            [showPlaceholder]="true"
            fe-placeholder
            [content]="contentParagragh"
            class="text-faq d-inline-block"
        ></p>
        <p
            [showPlaceholder]="true"
            fe-placeholder
            [content]="'Requirements for rent'"
            class="subtitle-faq d-inline-block"
        ></p>
        <p
            [showPlaceholder]="true"
            fe-placeholder
            [content]="contentParagragh"
            class="text-faq d-inline-block"
        ></p>
        <p
            [showPlaceholder]="true"
            fe-placeholder
            [content]="'Requirements for rent'"
            class="subtitle-faq d-inline-block"
        ></p>
        <p
            [showPlaceholder]="true"
            fe-placeholder
            [content]="contentParagragh"
            class="text-faq d-inline-block"
        ></p>
        <p
            [showPlaceholder]="true"
            fe-placeholder
            [content]="'Requirements for rent'"
            class="subtitle-faq d-inline-block"
        ></p>
        <p
            [showPlaceholder]="true"
            fe-placeholder
            [content]="contentParagragh"
            class="text-faq d-inline-block"
        ></p>
    </div>
</section>
<section class="container gx-0">
    <fe-button
        class="btn-back-questions mb-3"
        [style]="'link-tertiary'"
        [btnClass]="'p-0'"
        [icon]="'arrow-right-purple'"
        [iconPosition]="'left'"
        [href]="'questions' | formatUrl"
        >{{ 'fe_rental_policy_a_back-questions' | translate }}</fe-button
    >
    <fe-start-reservation></fe-start-reservation>
</section>
